<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='searchBtn' prefixIcon='icon hero-icon hero-icon-search' :tooltipText='$t("Track.search")' :click='buttonClk' operate='search'></e-item>
        <e-item v-if='exportBtn' prefixIcon='icon hero-icon hero-icon-export' :tooltipText='$t("Track.import")' :click='buttonClk' operate='import'></e-item>
      </e-items>
    </ejs-toolbar>
    <div v-if='keywordsInput' class='h-inputBox'>
      <ejs-textbox v-model='queryConditions.keywords' :placeholder='$t("Track.pleaseEnterQuery")' @keydown.native='updateKeywords'></ejs-textbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TsCommonMenu',
  props: {
    searchBtn: { type: Boolean, default: false },
    exportBtn: { type: Boolean, default: false },
    keywordsInput: { type: Boolean, default: false }
  },
  data() {
    return {
      queryConditions: {
        keywords: '', // 模糊查询关键字
      }
    };
  },
  methods: {
    buttonClk(args) {
      console.log(args);
      this.$emit('methodEnum', args.item.operate);
    },
    updateKeywords(clickEvent) {
      if (clickEvent.keyCode === 13) {
        this.$emit('keywords', this.queryConditions.keywords.trim());
      }
    }
  }
};
</script>

<style scoped>

</style>
